import { ISPDomains } from '../../constants/common';

export const isCorporateAndValidEmail = (e = '') => {
  const str = e.toLowerCase();
  if (
    !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      str
    )
  ) {
    return false;
  }

  const allowedPersonalEmails = [
    'maheshauti00@gmail.com',
    'sanjoli1097@gmail.com',
    'bmmc1990@gmail.com',
    // Add more allowed emails here
  ];

  if (allowedPersonalEmails.includes(str)) {
    return true;
  }

  // Check for ISP domains
  const emailDomain = str.split('@')[1]; // Extract domain from email
  if (ISPDomains.includes(emailDomain)) {
    return false; // ISP domain found
  }

  const nonCorporateDomains = [
    'gmail.com',
    'outlook.com',
    'hotmail.com',
    'yahoo.com',
    'me.com',
    'icloud.com',
    'msn.com',
    'live.com',
    'proton.me',
    '.edu',
    'ac.in',
  ];
  if (
    nonCorporateDomains.some((domain) => {
      if (domain === '.edu') {
        // e.g 00208922@uca.edu.sv
        return new RegExp('\\.edu(\\..+)?$').test(str);
      }
      return str.endsWith(domain);
    })
  ) {
    return false;
  }
  return true;
};
